import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Header from './components/Header';
import Footer from './components/Footer';
import CartPopup from './components/CartPopup'; // ✅ Cart popup component
import { CartProvider } from './context/CartContext'; // ✅ Cart context provider

import Home from './pages/Home';
import Quote from './pages/Quote';
import Sales from './pages/Sales';
import About from './pages/About';
import Contact from './pages/Contact';
import Feedback from './pages/Feedback';
import Plants from './pages/Plants';
import RequestQuote from './pages/RequestQuote'; // ✅ NEW: Request Quote page

function App() {
  return (
    <CartProvider> {/* ✅ Provide cart context globally */}
      <Router>
        <Header />
        <CartPopup /> {/* ✅ Show popup cart for all pages */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/plants" element={<Plants />} />
          <Route path="/request-quote" element={<RequestQuote />} /> {/* ✅ New route */}
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
